import {CookieConsent} from 'react-cookie-consent'
import {Box} from '@mui/material'
import React, {useState} from 'react'

import '@/styles/components/footer/footer.css'
import {colors} from '@/constants'
import TransCustom from '@/components/UI/i18next'

const Index = () => {
  const [visible, setVisible] = useState<string | undefined>(undefined)

  return (
    <Box style={{zIndex: 2000}}>
      <CookieConsent
        containerClasses="cookie-wrapper"
        buttonClasses="cookie-button"
        contentClasses="cookie-content"
        buttonText="Allow cookies"
        cookieName={'mog-cookie-accept'}
        visible={visible}
        onAccept={() => setVisible('hidden')}>
        <TransCustom
          i18nKey="1354"
          variant="body2"
          color={colors.brown}
          style={{textWrap: 'nowrap'}}
        />
        <TransCustom
          i18nKey="1355"
          variant="body2"
          color={colors.brown}
          style={{textWrap: 'nowrap'}}
        />
        {/*<Link marginLeft='5px'>*/}
        {/*  Learn more*/}
        {/*</Link>*/}
      </CookieConsent>
    </Box>
  )
}

export default Index
